import React from 'react';
import './CouponModalPremium.css'; // Ensure to place styles in this CSS file
import sageLogo from './sage.png'; // Adjust the path based on your structure

const CouponModalPremium = ({ coupon, coupons }) => {
  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    alert("Coupon code copied!");
  };

  return (
    <div className="coupon-card">
      <div className="coupon-left">
        <p className="salon-title">SAGE SALON</p>
        <p className="booking-title">BOOKING COUPON</p>
        {coupon.discount_type === 1 ? ( // Use strict equality for comparison
          <div className="discount">
            <p className="discount-title">DISCOUNT</p>
            <p className="discount-value">{coupon.discount_value}%</p>
          </div>
        ) : (
          <div className="discount">
            <p className="discount-title">FLAT</p>
            <p className="discount-value">{coupon.discount_value} $</p>
          </div>
        )}
      </div>
      <div className="coupon-right">
        <img src={sageLogo} alt="Sage Logo" className="logo-image" />
        <p className="coupon-name">{coupon.coupon_name}</p>
        <div className="code-section">
          <p className="code-label">CODE:</p>
          <p className="code-value">{coupons.coupon_code || '-'}</p> {/* Displaying the coupon code from referalCode */}
          <button className="copy-btn" onClick={() => copyCode(coupons.coupon_code)}>
            <i className="bx bx-copy"></i>
          </button>
        </div>
        <p className="valid-until">VALID UNTIL {coupon.to_date}</p>
      </div>
    </div>
  );
};

export default CouponModalPremium;
